import { onMounted, onUnmounted } from 'vue'

const SCRIPT_ID = 'landing-jsonld'

/** Совпадает с дефолтом в public/index.html после правки */
export const DEFAULT_DOCUMENT_TITLE = 'AI-Tenders — подбор тендеров под вашу компанию'

export const LANDING_SEO = {
  title: 'AI-Tenders — подбор релевантных тендеров под вашу компанию',
  description:
    'Ежедневная подборка закупок под профиль компании: мониторинг тендеров, отбор без лишнего шума, помощь специалиста с настройкой.',
  jsonLd: {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: 'AI-Tenders',
        url: '',
        email: 'Ai@neyrosvet.ru',
        telephone: '+7-953-341-65-48',
        address: {
          '@type': 'PostalAddress',
          addressLocality: 'Санкт-Петербург',
          addressCountry: 'RU',
        },
      },
      {
        '@type': 'SoftwareApplication',
        name: 'AI-Tenders',
        applicationCategory: 'BusinessApplication',
        operatingSystem: 'Web',
        offers: {
          '@type': 'Offer',
          price: '1',
          priceCurrency: 'RUB',
          description: 'Условия подключения предоставляются по заявке',
        },
        description:
          'Интеллектуальная система для тендеров и закупок в России и Казахстане: агрегированный поиск с площадок, ИИ-анализ документов, риски, критерии, маржа, прогноз победы, чат и согласования.',
      },
    ],
  },
}

function appendMeta(attrs) {
  const el = document.createElement('meta')
  for (const [k, v] of Object.entries(attrs)) {
    if (k === 'id') continue
    el.setAttribute(k, v)
  }
  el.dataset.landingSeo = '1'
  document.head.appendChild(el)
  return el
}

export function useLandingSeo() {
  let previousTitle = ''
  let previousDescription = null
  let descriptionWasCreated = false

  onMounted(() => {
    previousTitle = document.title
    document.title = LANDING_SEO.title

    const descEl = document.querySelector('meta[name="description"]')
    if (descEl) {
      previousDescription = descEl.getAttribute('content')
      descEl.setAttribute('content', LANDING_SEO.description)
    } else {
      descriptionWasCreated = true
      appendMeta({ name: 'description', content: LANDING_SEO.description })
    }

    const origin = window.location.origin
    appendMeta({ property: 'og:title', content: LANDING_SEO.title })
    appendMeta({ property: 'og:description', content: LANDING_SEO.description })
    appendMeta({ property: 'og:type', content: 'website' })
    appendMeta({ property: 'og:url', content: `${origin}/` })
    appendMeta({ name: 'twitter:card', content: 'summary_large_image' })
    appendMeta({ name: 'twitter:title', content: LANDING_SEO.title })
    appendMeta({ name: 'twitter:description', content: LANDING_SEO.description })
    appendMeta({
      name: 'robots',
      content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1',
    })

    const script = document.createElement('script')
    script.id = SCRIPT_ID
    script.type = 'application/ld+json'
    const ld = JSON.parse(JSON.stringify(LANDING_SEO.jsonLd))
    ld['@graph'][0].url = origin
    script.textContent = JSON.stringify(ld)
    document.head.appendChild(script)
  })

  onUnmounted(() => {
    document.title = previousTitle || DEFAULT_DOCUMENT_TITLE

    const desc = document.querySelector('meta[name="description"]')
    if (desc) {
      if (descriptionWasCreated) {
        desc.remove()
      } else if (previousDescription !== null) {
        desc.setAttribute('content', previousDescription)
      }
    }

    document.querySelectorAll('meta[data-landing-seo="1"]').forEach((el) => el.remove())
    document.getElementById(SCRIPT_ID)?.remove()
  })
}
